export const ROLES = { // тут не все роли
    DIRECTOR_DEPUTY_ACADEMIC: "director_deputy_academic",
    DIRECTOR_DEPUTY_ECONOMIC: "director_deputy_economic",
    DIRECTOR_DEPUTY_EDUCATION: "director_deputy_education",
    DIRECTOR_DEPUTY_INDUSTRIAL: "director_deputy_industrial",
    DIRECTOR_DEPUTY_METHODIST: "director_deputy_methodist"
}

export const DEPUTY_TYPES = [
    ROLES.DIRECTOR_DEPUTY_ACADEMIC,
    ROLES.DIRECTOR_DEPUTY_ECONOMIC,
    ROLES.DIRECTOR_DEPUTY_EDUCATION,
    ROLES.DIRECTOR_DEPUTY_INDUSTRIAL,
    ROLES.DIRECTOR_DEPUTY_METHODIST,
]